import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getQuery } from "app/views/tabellaPocr/ServiceController";

// Componenti chart già esistenti
import LineChart4 from "app/views/charts/echarts/LineChart4";
import LineChart2 from "app/views/charts/echarts/LineChart2";
import LoadingSpinner from "@gull/components/Loading/LoadingSpinner";
import ComunicazioniNews from "app/views/tabellaPocr/Comunicazioni/ComunicazioniNews";

const Dashboard = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const calledOnceRef = useRef(false);
    const [dataGrafico, setDataGrafico] = useState([]);
    const [dataSettimanale, setDataSettimanale] = useState([]);
    const [totSettimale, setTotSettimanale] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const [cardList, setCardList] = useState([
        {
            endpoint: "Anagrafiche/PazientiCount",
            icon: "i-Add-User",
            title: "0",
            subtitle: "Pazienti",
            bg: "bg-primary",
            isLoading: false,
        },
        {
            endpoint: "Referti/DaRefertare",
            icon: "i-Loading-3",
            title: "0",
            subtitle: "Da refertare",
            bg: "bg-success",
            isLoading: false,
        },
        {
            endpoint: "Referti/RefertiSalvati",
            icon: "i-Data-Save",
            title: "0",
            subtitle: "Referti salvati",
            bg: "bg-primary",
            isLoading: false,
        },
        {
            endpoint: "Referti/InviatiCount",
            icon: "i-Financial",
            title: "0",
            subtitle: "Referti Inviati",
            bg: "bg-success",
            isLoading: false,
        },
        {
            endpoint: "Referti/DaInviareCount",
            icon: "i-Checkout-Basket",
            title: "0",
            subtitle: "Referti da inviare",
            bg: "bg-warning",
            isLoading: false,
        },
        {
            endpoint: "Referti/ConErroreCount",
            icon: "i-Money-2",
            title: "0",
            subtitle: "Referti con errori",
            bg: "bg-danger",
            isLoading: false,
        },
    ]);

    const [newUserList, setNewUserList] = useState([]);
    const [isNewUserListLoading, setIsNewUserListLoading] = useState(false);

    useEffect(() => {
        if (!calledOnceRef.current) {
            calledOnceRef.current = true;
            dispatch(getQuery("Sedi/CheckSede"))
                .then((result) => {
                    if (!result) {
                        navigate("/info-account", {
                            state: {
                                hide: true,
                            },
                        });
                    }
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, [dispatch, navigate]);

    useEffect(() => {
        const fetchAllCardTitles = async () => {
            try {
                // Imposta lo stato di loading su true per tutte le card
                setCardList((prevCards) =>
                    prevCards.map((card) => ({ ...card, isLoading: true }))
                );

                const requests = cardList.map((card) =>
                    dispatch(getQuery(card.endpoint))
                );

                // Aspettiamo tutte le risposte
                const responses = await Promise.all(requests);

                // Aggiorniamo le card col valore "title" preso dal server
                setCardList((prevCards) =>
                    prevCards.map((card, index) => ({
                        ...card,
                        title: responses[index] || "0",
                        isLoading: false,
                    }))
                );
            } catch (error) {
                console.error(error);
                // In caso di errore, rimuovo i loader
                setCardList((prevCards) =>
                    prevCards.map((card) => ({ ...card, isLoading: false }))
                );
            }
        };

        // Funzione per caricare la newUserList
        const fetchNewUserList = async () => {
            try {
                setIsNewUserListLoading(true);
                // Chiamata singola per la newUserList
                const response = await dispatch(getQuery("Referti/Newers"));
                // Aggiorno lo stato
                setNewUserList(response || []);
                setIsNewUserListLoading(false);
            } catch (error) {
                console.error(error);
                setIsNewUserListLoading(false);
            }
        };

        const fetchDataChartSettimanale = async () => {
            try {
                // Chiamata singola per la newUserList
                const response = await dispatch(getQuery("Accettazione/GetConteggiData/7"));
                // Aggiorno lo stato
                setDataSettimanale(response || []);
                let somma = response.reduce((acc, valore) => acc + parseInt(valore, 10), 0);
                setTotSettimanale(somma);
            } catch (error) {
                console.error(error);
            }
        }

        const fetchDataChartAnnuale = async () => {
            try {
                // Chiamata singola per la newUserList
                const response = await dispatch(getQuery("Accettazione/GetConteggiData/30"));
                // Aggiorno lo stato
                setDataGrafico(response || []);
            } catch (error) {
                console.error(error);
            }
        }

        // Avvio in parallelo le due funzioni
        fetchAllCardTitles();
        fetchNewUserList();
        fetchDataChartSettimanale();
        fetchDataChartAnnuale();
    }, []);

    return (
        <>
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <div>
                    <div className="row d-flex justify-content-around">
                        {cardList.map((card, index) => (
                            <div key={index} className="col-lg-3 col-md-6 col-sm-6">
                                <div
                                    className={`card card-icon-bg card-icon-${card.bg} o-hidden mb-4`}
                                >
                                    <div className="card-body text-center">
                                        <i className={card.icon}></i>
                                        <div className="content" style={{ maxWidth: 200 }}>
                                            <p className="text-muted mt-2 mb-0">{card.subtitle}</p>
                                            <p className="lead text-primary text-24 mb-2 text-capitalize">
                                                {card.isLoading ? "Caricamento..." : card.title}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <hr />

                    <div className="d-flex justify-content-around">
                        <div className="col-4 text-center">
                            <div className="border border-success border-1 rounded-4">
                                <div className="card-body">
                                    <div className="ul-product-detail__border-box">
                                        <div className="ul-product-detail--icon mb-2">
                                            <i className="i-Address-Book text-success text-25 font-weight-500 "></i>
                                        </div>
                                        <h5 className="heading">Nuovo referto</h5>
                                        <Link to={`/accettazione/index`}>
                                            <p className="btn btn-success text-white w-50">
                                                <i className="i-Address-Book"></i>&nbsp;&nbsp;Crea un nuovo referto
                                            </p>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-4 text-center">
                            <div className="border border-primary border-1 rounded-4">
                                <div className="card-body">
                                    <div className="ul-product-detail__border-box">
                                        <div className="ul-product-detail--icon mb-2">
                                            <i className="i-Receipt-4 text-primary text-25 font-weight-500 "></i>
                                        </div>
                                        <h5 className="heading">Elenco referti</h5>
                                        <Link to={`/refertazione/1`}>
                                            <p className="btn btn-primary text-white w-50">
                                                <i className="i-Receipt-4"></i>&nbsp;&nbsp;Vai all'elenco
                                            </p>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr />

                    <div className="row">
                        <div className="col-12 my-3">
                            <div className="row">
                                <div className="col-9">
                                    <Link
                                        to="https://www.refertofse.it/approfondimenti-e-vantaggi/2025/11/28/refertofse-guida-completa-allaccettazione-e-refertazione-digitale/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-decoration-none"
                                    >
                                        <div className="card border-primary shadow-sm p-3 bg-soft-blue">
                                            <div className="d-flex align-items-center">
                                                <span className="me-2 fs-4 text-primary">📘</span>
                                                <p className="mb-0 fw-bold text-primary">
                                                    Guida al primo utilizzo del Fascicolo Sanitario Elettronico (FSE)
                                                </p>
                                            </div>
                                        </div>
                                    </Link>
                                    <div className="my-3" >
                                        <ComunicazioniNews />
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="card mb-4">
                                        <div className="card-title card-body mb-0 pb-0">
                                            <h3 className="mb-4">Referti ultima settimana</h3>
                                            <p className="text-primary mb-0 text-24">{totSettimale}</p>
                                        </div>
                                        <LineChart2 height="340px" dataGrafico={dataSettimanale} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="card mb-4">
                                <div className="card-body pb-4">
                                    <h5 className="card-title m-0 p-3">Adamento ultimi 30 giorni</h5>
                                    <LineChart4 height="369px" dataGrafico={dataGrafico} ></LineChart4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Dashboard;